import React from 'react';
import { default as FormLabelMaterial, FormLabelProps } from '@material-ui/core/FormLabel';
import { makeFormLabelStyles } from 'styles/components/formLabel';

const FormLabel: React.FC<FormLabelProps> = ({ children, htmlFor, required, ...props }) => {
    const formLabelClasses = makeFormLabelStyles({ required });

    return (
        <FormLabelMaterial classes={formLabelClasses} htmlFor={htmlFor} {...props}>
            {children}
        </FormLabelMaterial>
    );
};

export default FormLabel;
